import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="45" viewBox="0 0 66 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1_18)">
      <path d="M66 0H0V44.1818H66V0Z" fill="#21468B" />
      <path d="M66 0H0V29.4545H66V0Z" fill="white" />
      <path d="M66 0H0V14.7273H66V0Z" fill="#AE1C28" />
      <path d="M66 0H0V44H66V0Z" stroke="#9F9D9D" />
    </g>
    <defs>
      <clipPath id="clip0_1_18">
        <rect width="66" height="44.1818" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
